import { z } from 'zod';
import { CateringEventModelSchema } from 'entities/catering-event';
import { GetCateringEventsByFormatSlugApiResponseSchema } from '../store';

export const createCateringEventsFromGetCateringEventsByFormatSlugApiResponse = (
    (response: z.infer< typeof GetCateringEventsByFormatSlugApiResponseSchema>) => (
        response.data.map(({
            name,
            description,
            images,
            format,
            slug,
        }) => CateringEventModelSchema.parse({
            uid: slug,
            name,
            slug,
            description,
            images: images?.map(({ url }) => ({
                url,
            })),
            format: format && ({
                name: format.name,
            }),
        }))
    )
);
